/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  contain: content;
  border: 0;
  outline: 0;
  text-align: left;
  display: block;
}

:host([hidden]) {
  display: none;
}

.container {
  display: flex;
  height: inherit;
  padding: 1.1428571429rem 0.8571428571rem 1.1428571429rem 0.8571428571rem;
  border-left: 0.2857142857rem solid;
}
.container .icon {
  display: block;
  height: 1.7142857143rem;
  width: 1.7142857143rem;
  min-width: 1.7142857143rem;
  min-height: 1.7142857143rem;
  margin-right: 0.5714285714rem;
}
.container .text {
  flex: 1;
  line-height: 1.6;
  margin-right: 1.1428571429rem;
}
.container.info {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-light, #e5f1f8);
  border-color: var(--davinci-color-information, #007cc1);
}
.container.info .text {
  color: #2C3133;
  color: var(--davinci-color-text-on-information-light, #2C3133);
}
.container.info .icon {
  fill: #007cc1;
  fill: var(--davinci-color-information, #007cc1);
}
.container.info .close {
  color: #2C3133;
  color: var(--davinci-color-text-on-information-light, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-text-on-information-light, #2C3133);
}
.container.success {
  background-color: #EFF7E7;
  background-color: var(--davinci-color-success-light, #EFF7E7);
  border-color: var(--davinci-color-success, #63b017);
}
.container.success .text {
  color: #2C3133;
  color: var(--davinci-color-text-on-success-light, #2C3133);
}
.container.success .icon {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}
.container.success .close {
  color: #2C3133;
  color: var(--davinci-color-text-on-success-light, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-text-on-success-light, #2C3133);
}
.container.error {
  background-color: #FCE6E9;
  background-color: var(--davinci-color-error-light, #FCE6E9);
  border-color: var(--davinci-color-error, #ea0823);
}
.container.error .text {
  color: #2C3133;
  color: var(--davinci-color-text-on-error-light, #2C3133);
}
.container.error .icon {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}
.container.error .close {
  color: #2C3133;
  color: var(--davinci-color-text-on-error-light, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-text-on-error-light, #2C3133);
}
.container.warning {
  background-color: #FEF9E7;
  background-color: var(--davinci-color-warning-light, #FEF9E7);
  border-color: var(--davinci-color-warning, #f5c413);
}
.container.warning .text {
  color: #2C3133;
  color: var(--davinci-color-text-on-warning-light, #2C3133);
}
.container.warning .icon {
  fill: #F5C413;
  fill: var(--davinci-color-warning, #F5C413);
}
.container.warning .close {
  color: #2C3133;
  color: var(--davinci-color-text-on-warning-light, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-text-on-warning-light, #2C3133);
}
.container .close {
  cursor: pointer;
  flex: 0 0 auto;
  width: 1.2857142857rem;
  height: 1.2857142857rem;
}`;
export { style };
